import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { Login } from '@/components/Login'

const signInSchema = z.object({
  redirect: z.string().optional().default('/dashboard'),
})

export const Route = createFileRoute('/login')({
  validateSearch: signInSchema,
  beforeLoad: ({ context, search }) => {
    if (context.session) {
      throw redirect({ to: search.redirect })
    }
  },
  component: LoginComp,
})

function LoginComp() {
  return <Login />
}
